module.exports = __webpack_public_path__ + "static/ReDeals-d92cb611b1ee25174e07228e340f9c54.png";